import { ORDER_LOADER, GET_ORDER_HISTORY, GETPAYMENT_METHOD } from "../types";
import { AES, enc } from "crypto-js";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
export const orderLoader = (val) => async (dispatch) => {
  dispatch({
    type: ORDER_LOADER,
    payload: val,
  });
};

export const addOrderAction =
  (payload, onSuccess, onError = () => {}) => async (dispatch) => {
    let orderId = uuidv4();
    const { answers, ...orderData } = payload;
    try {
      dispatch(orderLoader(true));

      const orderRef = firebase.firestore().collection("orders").doc(orderId);
      const orderPayload = {
        ...orderData,
        deliveryAddress: orderData?.deliveryAddress || "",
        createdAt: firebase.firestore.Timestamp.now(),
        orderId,
      };
      await orderRef.set(orderPayload);

      let batch = firebase.firestore().batch();

      Object.entries(answers).forEach(([questionId, answer]) => {
        let docRef = firebase.firestore().collection("checkoutResponses").doc();
        batch.set(docRef, {
          answer: answer.answer,
          customerId: answer.customerId,
          orderId,
          customerName: answer?.customerName,
          customerAge: answer?.customerAge || "",
          customerGender: answer?.customerGender || "",
          questionId,
          createdAt: firebase.firestore.Timestamp.now(),
        });
      });

      await batch.commit();

      toast.success("Order placed successfully");
      onSuccess(orderId);
    } catch (error) {
      console.error("Order submission error:", error);
      toast.error(
        "Something went wrong while placing your order. Please try again."
      );
      onError(error.message);
    } finally {
      dispatch(orderLoader(false));
    }
  };

export const updateOrderAction =
  (payload, onSuccess, onError) => async (dispatch) => {
    const { OrderId } = payload;

    try {
      dispatch(orderLoader(true));
      await firebase
        .firestore()
        .collection("orders")
        .doc(OrderId)
        .update({
          tipPayment: {
            ...payload,
            paymentRecieved: true,
            tipAdded: true,
          },
        });

      dispatch(orderLoader(false));

      if (onSuccess) onSuccess();

      toast.success("Order updated successfully!");
    } catch (err) {
      dispatch(orderLoader(false));
      if (onError) onError(err);

      toast.error(`Failed to update order: ${err.message}`);
    }
  };

export const getOrders = (payload) => async (dispatch) => {
  dispatch({
    type: "GET_ORDER_LOADER",
    payload: payload,
  });
};

export const getOrderHistoryAction = (uid) => async (dispatch) => {
  try {
    dispatch(getOrders(true));
    firebase
      .firestore()
      .collection("orders")
      .where("customerID", "==", uid)
      .orderBy("createdAt", "desc")
      .onSnapshot(async (query) => {
        let temp = [];
        for (let doc of query.docs) {
          temp.push({ id: doc.id, ...doc.data() });
        }
        dispatch({ type: GET_ORDER_HISTORY, payload: temp });
        dispatch(getOrders(false));
      });
  } catch (err) {
    toast.error(err.message);
    dispatch(getOrders(false));
  }
};

export const updateOrderLoader = (payload) => async (dispatch) => {
  dispatch({
    type: "UPDATE_ORDER_LOADER",
    payload: payload,
  });
};

export const updateOrder = (item, status) => async (dispatch, getState) => {
  try {
    dispatch(updateOrderLoader(item.id));
    const orderRef = firebase.firestore().collection("orders").doc(item?.id);
    await orderRef.update({ status });
    dispatch({
      type: "UPDATE_SINGLE_ORDER",
      payload: { orderId: item.id, status },
    });
  } catch (error) {
    console.error("Order update failed:", error);
  } finally {
    dispatch(updateOrderLoader(""));
  }
};

export const getPaymentMethodAction = (id) => async (dispatch) => {
  try {
    await firebase
      .firestore()
      .collection("paymentMethods")
      .where("customerID", "==", id)
      .get()
      .then((data) => {
        let temp = [];
        for (let i = 0; i < data?.docs?.length; i++) {
          let result = decryptCardObject(data?.docs[i]?.data()?.card);
          temp.push({
            id: data?.docs[i]?.id,
            ...result,
            sample: data?.docs[i]?.data()?.sample,
          });
        }
        dispatch({
          type: GETPAYMENT_METHOD,
          payload: temp,
        });
      });
  } catch (e) {
    toast.error(e?.response?.data?.message);
  }
};

export const updateMethodAction = (obj, onSuccess) => async (dispatch) => {
  dispatch(updatePaymentLoader(true));
  try {
    let sampleCard = maskCardNumber(obj?.card?.number);
    let storeCard = encryptCardObject(obj?.card);
    await firebase
      .firestore()
      .collection("paymentMethods")
      .doc(obj?.cardID)
      .update({
        customerID: obj?.customerID,
        sample: sampleCard,
        card: storeCard,
      })
      .then((data) => {
        onSuccess();
        dispatch(getPaymentMethodAction(obj?.customerID));
        dispatch(updatePaymentLoader(false));
      });
  } catch (e) {
    toast.error(e?.response?.data?.message);
    dispatch(updatePaymentLoader(false));
  }
};

export const restaurantVisitorAdd = (obj) => async (dispatch) => {
  try {
    firebase.firestore().collection("visits").add(obj);
  } catch (err) {
    toast.error(err.message);
  }
};
export const deleteCardAction = (id, uid) => async (dispatch) => {
  try {
    await firebase
      .firestore()
      .collection("paymentMethods")
      .doc(id)
      .delete()
      .then((data) => {
        dispatch(getPaymentMethodAction(uid));
        toast.success("Order Deleted Successfully!");
      });
  } catch (e) {
    toast.error(e?.response?.data?.message);
  }
};

export const addCardAction = (obj, id) => async (dispatch) => {
  try {
    let sampleCard = maskCardNumber(obj?.card?.number);
    let storeCard = encryptCardObject(obj?.card);
    await firebase.firestore().collection("paymentMethods").add({
      customerID: id,
      sample: sampleCard,
      card: storeCard,
    });
  } catch (e) {
    toast.error(e?.response?.data?.message);
  }
};

const maskCardNumber = (card) => {
  const visibleDigits = 4;
  const maskedDigits = card?.length - visibleDigits;
  const maskedChars = "*".repeat(maskedDigits);
  return `${maskedChars}${card?.slice(-visibleDigits)}`;
};
const encryptCardObject = (object) => {
  const jsonString = JSON.stringify(object);
  const encryptedData = AES.encrypt(jsonString, "ENCRYPTION_KEY").toString();

  return encryptedData;
};

const decryptCardObject = (encryptedData) => {
  // Decrypt the encrypted data
  const decryptedBytes = AES.decrypt(encryptedData, "ENCRYPTION_KEY");
  const decryptedString = decryptedBytes.toString(enc.Utf8);

  // Parse the decrypted JSON string to an object
  const decryptedObject = JSON.parse(decryptedString);

  return decryptedObject;
};

export const updatePaymentLoader = (payload) => async (dispatch) => {
  dispatch({
    type: "UPDATE_PAYMENT_LOADER",
    payload: payload,
  });
};
